import { FC } from "react";

import { SidebarHeader } from "@tsmono/react/components";

import styles from "./SearchScoutUnavailable.module.css";

const SCOUT_DOCS_URL = "https://meridianlabs-ai.github.io/inspect_scout/";

/**
 * Shown in place of the search panel when the backend reports that
 * inspect_scout (which powers the search endpoints) is not installed.
 */
export const SearchScoutUnavailable: FC<{ onClose: () => void }> = ({
  onClose,
}) => (
  <div className={styles.container}>
    <SidebarHeader icon="search" title="Search" onClose={onClose} />
    <div className={styles.body}>
      <p>Please install Inspect Scout to enable search</p>
      <p>
        <a href={SCOUT_DOCS_URL} target="_blank" rel="noreferrer">
          Learn more
        </a>
      </p>
    </div>
  </div>
);
